<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import StarRating from "vue-star-rating";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Swal from "sweetalert2";
import router from "@/router";
import FreeWorld from "@/assets/js/FreeWorld";

export default {
  name: "CommentOrders",
  components: {StarRating, LoadingPage},
  setup(){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()
    let loading = ref(false)
    let username = ref(store.state.my_profile.full_name)

    let ord_id = useRoute().params.ord_id

    let unit = ref({
      id: null,
      comment: null,
      rating: null
    })

    let products = ref([])

    function load_comment() {

      loading.value = true
      FreeWorld.Heisenberg({ action: 'show', order_id: ord_id,} , 'comments').then((result)=>{

        loading.value = false
        let res = result.data
        unit.value.id = res.unit_id
        res.products.forEach((item)=>{
          item.rating = null
          item.comment = null
        })
        products.value = res.products

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              load_comment()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              load_comment()
            }
          })
        }
      })

    }
    load_comment()

    function send_comment() {

      let data = {
        action : "comments",
        order_id : ord_id,
        store_id : unit.value.id,
        store_rating : unit.value.rating,
        store_comment : unit.value.comment,
        product : []
      }

      if (unit.value.comment != null || unit.value.rating != null){
        if (unit.value.comment == null || unit.value.comment.trim().length == 0 || unit.value.rating == null){
          Swal.fire({
            position: "center",
            icon: "error",
            title: "لطفا نظر و امتیاز خود را راجب به فروشگاه به صورت صحیح وارد کنید",
            showConfirmButton: true,
            confirmButtonText:'متوجه شدم'
          })
          return false
        }
      }

      let x = true
      products.value.forEach((item)=>{
        if (x) {
          if (item.rating != null || item.comment != null) {
            if (item.rating == null || item.comment == null || item.comment.trim().length == 0) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "لطفا نظر و امتیاز خود را راجب به محصول به صورت صحیح وارد کنید",
                showConfirmButton: true,
                confirmButtonText: 'متوجه شدم'
              })
              x =  false
              return false
            } else {
              data.product.push({id: item.product_id, rating: item.rating, comment: item.comment})
            }
          }
        }
      })

      if (!x) return false

      loading.value = true
      FreeWorld.Heisenberg(data , 'comments' , true).then((result)=> {

        loading.value = false
        let res = result.data
        if (res.status == 'ok') {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "نظرات شما با موفقیت ثبت شد",
            showConfirmButton: false,
            timer: 1500
          }).then(()=>{
            router.push({name:'HomePage'})
          })
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "متاسفانه نظرات شما ثبت نشد",
            showConfirmButton: true,
            confirmButtonText:'متوجه شدم'
          })
        }
      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              send_comment()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              send_comment()
            }
          })
        }
      })

    }

    return{

      loading,
      username,
      products,
      unit,
      send_comment,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="" :class="loading ? 'activeClass' : '' " class="main bg-color p-body">
    <div class="d-flex align-items-center justify-content-between font-color-white mt-4 mb-2">
      <!--      <img onclick="history.back()" style="width: 20px" src="../assets/img/closing.svg" alt="">-->
      <p class="m-0 font-3 text-center w-100 my-3">
        ثبت نظر سنجی
      </p>
    </div>
    <div class="container-fluid bg-white p-3 rounded-4 mb-5">
      <img class="stars_svg m-auto d-block" src="../assets/img/stars.svg" alt="">

      <p class="w-100 text-center">
        <span>{{ username }}</span>
        عزیز
      </p>
      <p class="w-100 text-center font-4">
        لطفا نظر خود را در ارتباط با این سفارش با ما به اشتراک بگذارید
      </p>

      <div class="bg-costom p-body rounded-4 mb-3">
        <div class="d-flex justify-content-between align-items-center py-3">
          <div class="">
            <star-rating :star-size="25" class="position-relative overflow-hidden" :show-rating="false" v-model:rating="unit.rating" :animate="false"></star-rating>
          </div>

          <p class="m-0 font-4">
            امتیاز شما به کیفیت فروشگاه
          </p>
        </div>

        <textarea v-model="unit.comment" class="textarea_users p-3 font-4 w-100 bg-white border-costom mb-3 rounded-4" placeholder=""></textarea>
      </div>


      <div v-for="item in products" :key="item.product_id" class="bg-costom mb-3 p-body rounded-4">
        <div class="d-flex justify-content-between align-items-center py-3">
          <div class="">
            <star-rating :star-size="25" class="position-relative overflow-hidden" :show-rating="false" v-model:rating="item.rating" :animate="false"></star-rating>
          </div>

          <p class="m-0 font-4">
            امتیاز شما به محصول
          </p>
        </div>

        <div class="d-flex justify-content-end">
          <div class="mx-2 d-flex flex-column justify-content-around">
            <p class="font-4 font-bold text-end">{{ item.name }}</p>
            <div class="">
              <p class="mx-3 d-flex font-4" :class="item.off_price != null ? 'text-decoration-line-through' : '' ">
                <span class="pr-1">تومان</span>
                <span>{{ item.price.toLocaleString() }}</span>
              </p>

              <p v-if="item.off_price != null" class="font-color font-4 mx-3 d-flex">
                <span class="mr-1">تومان</span>
                <span>{{ item.off_price.toLocaleString() }}</span>
              </p>
            </div>
          </div>
          <div>
            <img v-if="item.pic == null" class="rounded-4 img_prod" src="../assets/img/img-notavalible.jpg" alt="">
            <img v-else class="rounded-4 img_prod" :src="item.pic" alt="">
          </div>
        </div>
        <br>
        <textarea v-model="item.comment" class="textarea_users p-3 font-4 w-100 border-costom mb-3 bg-white rounded-4" placeholder=""></textarea>
      </div>

      <div class="button_div w-100 d-flex justify-content-center bg-white">
        <v-btn @click="send_comment" style="height: 50px" class="w-45 bg-color rounded-2 border-costom text-white my-2 ">
          ثبت نظر
        </v-btn>
      </div>
    </div>
  </div>

</template>

<style scoped>

.main{
  width: 100vw;
  min-height: 100dvh;
  background-color: #ffffff;
  overflow-x: hidden;
  user-select: none;
}

.stars_svg {
  width: 10rem;
}

.textarea_users {
  height: 100px;
  resize: none;
}

.img_prod{
  width: 8rem;
  height: 8rem;
}

@media (max-width: 700px) {
  .img_prod{
    width: 5rem;
    height: 5rem;
  }
}

</style>